import { Routes } from '@angular/router';
import { adminGuard } from './core/admin.guard';
import { AuthComponent } from './core/auth/auth.component';
import { userGuard } from './core/user.guard';
import { FaqComponent } from './pages/faq/faq.component';
import { ProvablyFairComponent } from './pages/provably-fair/provably-fair.component';
import { TosComponent } from './pages/tos/tos.component';
import { ProfileMainComponent } from './profile/profile-main/profile-main.component';
import { ProfileSelfExclusionComponent } from './profile/profile-self-exclusion/profile-self-exclusion.component';
import { ProfileComponent } from './profile/profile.component';
import { DepositComponent } from './store/deposit.component';
import { WithdrawComponent } from './store/withdraw.component';
import { HistoryModalComponent } from '@shared/modals/history-modal/history-modal.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@features/home/home.component').then((m) => m.HomeComponent),
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: AuthComponent,
  },
  {
    path: 'profile',
    canActivate: [userGuard],
    component: ProfileComponent,
    children: [
      {
        path: '',
        component: ProfileMainComponent,
      },
      {
        path: 'history',
        component: HistoryModalComponent,
        data: { tabsType: 'history' },
      },
      {
        path: 'transactions',
        component: HistoryModalComponent,
        data: { tabsType: 'transactions' },
      },
      {
        path: 'self-exclusion',
        component: ProfileSelfExclusionComponent,
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
  {
    path: 'deposit',
    component: DepositComponent,
  },
  {
    path: 'withdraw',
    component: WithdrawComponent,
  },
  {
    path: 'tos',
    component: TosComponent,
  },
  {
    path: 'faq',
    component: FaqComponent,
  },
  {
    path: 'provably-fair',
    component: ProvablyFairComponent,
  },
  {
    path: 'provably-fair/:gamemode',
    component: ProvablyFairComponent,
  },
  {
    path: 'provably-fair/:gamemode/:roundid',
    component: ProvablyFairComponent,
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadChildren: () => import('@features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  },
  { path: 'coinflip', loadChildren: () => import('@features/coinflip/coinflip.routes').then((m) => m.COINFLIP_ROUTES) },
  {
    path: 'r/:affCode',
    loadComponent: () => import('@features/affiliates/affiliates.component').then((m) => m.AffiliatesComponent),
  },
  {
    path: 'p/:promoCode',
    loadComponent: () => import('@features/affiliates/affiliates.component').then((m) => m.AffiliatesComponent),
  },
  { path: 'affiliates', loadComponent: () => import('@features/affiliates/affiliates.component').then((m) => m.AffiliatesComponent) },
  { path: 'leaderboard', loadComponent: () => import('@features/leaderboard/leaderboard.component').then((m) => m.LeaderboardComponent) },
  { path: 'raffles', loadComponent: () => import('@features/raffles/raffles.component').then((m) => m.RafflesComponent) },
  { path: 'plinko', loadChildren: () => import('@features/plinko/plinko.routes').then((m) => m.PLINKO_ROUTES) },
  { path: 'cases', loadChildren: () => import('@features/case-open/case-open.routes').then((m) => m.CASE_OPEN_ROUTES) },
  { path: 'battles', loadChildren: () => import('@features/case-battles/case-battles.routes').then((m) => m.CASE_BATTLES_ROUTES) },
  { path: 'mines', loadChildren: () => import('@features/mines/mines.routes').then((m) => m.MINES_ROUTES) },
  { path: 'towers', loadChildren: () => import('@features/towers/towers.routes').then((m) => m.TOWERS_ROUTES) },
  { path: 'rewards', loadChildren: () => import('@features/rewards/rewards.routes').then((m) => m.REWARDS_ROUTES) },
  { path: 'king', loadChildren: () => import('@features/king/king.routes').then((m) => m.KING_ROUTES) },
  { path: 'jackpot', loadComponent: () => import('@features/jackpot/jackpot.component').then((m) => m.JackpotComponent) },

  {
    path: '**',
    redirectTo: '',
  },
];
